<template>
  <v-form>
    <!-- システムログ -->
    <v-container>
      <v-card class="parkingSelect" false>
        <v-card-title>システムログ</v-card-title>
        <v-row>
          <v-col cols="2" class="headerTitle">
            <ryou-date-format
              ref="ryou_date_format1"
              v-model="fromDate"
              :value="fromDate"
              :type="'date'"
              :rules="monthRules"
              :label="'出力期間FROM'"
              :format="'$1/$2/$3'"
              :max="selectMax"
            >
            </ryou-date-format>
          </v-col>
          <v-col cols="2" class="headerTitle">
            <ryou-date-format
              ref="ryou_date_format2"
              v-model="toDate"
              :value="toDate"
              :type="'date'"
              :rules="monthRules"
              :label="'出力期間TO'"
              :format="'$1/$2/$3'"
              :min="selectMin"
            >
            </ryou-date-format>
          </v-col>
        </v-row>
      </v-card>
      <v-card class="risuto">
        <v-form ref="tableForm" v-model="tableForm" lazy-validation>
          <ryou-table
            ref="ryouTable"
            :rowKey="rowKey"
            :headers="headers"
            :needSearch="true"
            :dummy="false"
            :url="url"
            :height="800"
            :businessKey="businessKey"
            :queryParams="queryParams"
            style="margin-top: 10px"
            :autoLoad="false"
          >
            <v-row slot="filterContainer"> </v-row>
          </ryou-table>
        </v-form>
      </v-card>
    </v-container>
  </v-form>
</template>

<script>
import RyouDateFormat from "@/components/formInput/RyouDateFormat.vue";
import RyouTable from "@/components/table/RyouTable.vue";
import { RyouTableMixins } from "@/mixins/RyouTableMixins";
export default {
  name: "MasterSystemLog",
  mixins: [RyouTableMixins],
  components: {
    RyouTable,
    RyouDateFormat,
  },
  mounted() {
    this.monthRules.push(this.GlobalRules.required);
  },
  data() {
    return {
      tableForm: true,
      fromDate: "",
      toDate: "",
      monthRules: [],
      selectMin: "",
      selectMax: "",
      queryParams: {
        userId: this.$store.getters.getUserId,
        userClass: this.$store.getters.getUserClass,
        fromDate: "",
        toDate: "",
      },
      businessKey: "syslog_seq_no",
      rowKey: "syslog_seq_no",
      headers: [
        {
          text: "No",
          class: "blue lighten-2 title",
          value: "syslog_seq_no",
          align: "center",
          width: "4%",
          sortable: true,
          groupable: false,
        },
        {
          text: "区分",
          class: "blue lighten-2 title",
          value: "message_name",
          align: "center",
          width: "5%",
          sortable: true,
          groupable: false,
        },
        {
          text: "実施日時",
          class: "blue lighten-2 title",
          value: "reg_date",
          align: "center",
          width: "10%",
          sortable: true,
          groupable: false,
        },
        {
          text: "ユーザID",
          class: "blue lighten-2 title",
          value: "reg_user_id",
          align: "center",
          width: "7%",
          sortable: true,
          groupable: false,
        },
        {
          text: "機能ID",
          class: "blue lighten-2 title",
          value: "function_id",
          align: "center",
          width: "6%",
          sortable: true,
          groupable: false,
        },
        {
          text: "メッセージ",
          class: "blue lighten-2 title",
          value: "message",
          align: "left",
          width: "68%",
          groupable: false,
        },
      ],
      url: {
        list: "/masterSystem/systemLogGet",
      },
    };
  },
  created() {
    this.initData();
  },
  watch: {
    fromDate() {
      this.setDate();
      this.selectMin = this.fromDate;
      this.loadDate();
    },
    toDate() {
      this.setDate();
      this.selectMax = this.toDate;
      this.loadDate();
    },
  },
  methods: {
    // 初期化
    initData() {
      const tmpdate = new Date();
      tmpdate.setDate(tmpdate.getDate() + 1);
      const mm = ("00" + (tmpdate.getMonth() + 1)).slice(-2);
      const dd = ("00" + tmpdate.getDate()).slice(-2);
      this.toDate = tmpdate.getFullYear() + "-" + mm + "-" + dd;
      const tmpdate2 = new Date();
      tmpdate2.setDate(tmpdate2.getDate() - 7);
      const mm2 = ("00" + (tmpdate2.getMonth() + 1)).slice(-2);
      const dd2 = ("00" + tmpdate2.getDate()).slice(-2);
      this.fromDate = tmpdate2.getFullYear() + "-" + mm2 + "-" + dd2;
    },
    setDate() {
      this.$refs.ryou_date_format1.initViewDate(this.fromDate);
      this.$refs.ryou_date_format2.initViewDate(this.toDate);
    },
    // データの読み込みを行う
    loadDate() {
      // console.log(this.fromDate);
      this.$refs.ryouTable.clearTable();
      this.queryParams.fromDate = this.fromDate;
      this.queryParams.toDate = this.toDate;
      this.queryParams.userId = this.$store.getters.getUserId;
      this.queryParams.userClass = this.$store.getters.getUserClass;
      this.$refs.ryouTable.loadData();
    },
  },
};
</script>

<style scoped></style>
